import type { AvatarFallbackComponentProps } from '@frameio/vapor';
import { theme } from '@frameio/vapor';
import { IconCompareLink } from '@frameio/vapor-icons';

export const WorkfrontDefaultAvatar = ({
  height,
  width,
}: AvatarFallbackComponentProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 40 40"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0h40v40H0z" fill={theme.colors.background.primary} />
    <g transform="translate(8, 8)">
      <IconCompareLink
        color={theme.colors.icon.secondary}
        data-testid={'workfront-avatar'}
        size={24}
      />
    </g>
  </svg>
);
